import { ROOT_FONT_SIZE } from '../constants/styleConstants';

const pxToRem = (size = 0): string => {
  return `${size / ROOT_FONT_SIZE}rem`;
};

export default pxToRem;
